module.exports = __webpack_public_path__ + "img/navbar-image.37aa6599.svg";